import React from 'react';
import Pikaday from 'pikaday';
import { string, number, func } from 'prop-types';

class Datepicker extends React.Component {
    // Validate data for props
    static propTypes = {
        datepickerID: string.isRequired,
        placeholderText: string.isRequired,
        minDate: number.isRequired,
        maxDate: number.isRequired,
        defaultDate: number,
        handleDate: func.isRequired
    };

    static defaultProps = { defaultDate: 0 }

    componentDidMount() {
        const self = this;
        const minDate = new Date(this.props.minDate);
        const maxDate = new Date(this.props.maxDate);

        const handleFunc = this.props.handleDate;
        this.pikaObject = new Pikaday({
            field: self.pikadayNode,
            format: 'DD MMM YY',
            firstDay: 1,
            minDate,
            maxDate,
            disableWeekends: false,
            onSelect: date => {
                handleFunc(date);
            }
        });

        this.setPikadayInput(this.props);
    }

    shouldComponentUpdate(nextProps) {
        if (Number.isNaN(this.props.defaultDate) && Number.isNaN(nextProps.defaultDate)) {
            return false;
        }

        return (this.props.defaultDate !== nextProps.defaultDate);
    }

    componentWillUpdate(nextProps) {
        this.setPikadayInput(nextProps);
    }

    setPikadayInput(theProps) {
        if (theProps.defaultDate) {
            const monthNames = [
                'JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'
            ];
            const dDate = new Date(theProps.defaultDate);
            const subYear = dDate.getFullYear().toString().substr(-2);
            this.pikaObject.setDate(dDate);
            this.pikaObject.gotoDate(dDate);
            this.pikadayNode.value = `${dDate.getDate()} ${monthNames[dDate.getMonth()]} ${subYear}`;
        } else {
            this.pikaObject.setDate(null);
            this.pikaObject.gotoDate(new Date());
            this.pikadayNode.value = '';
        }
    }

    render() {
        return (
            <div className="react-pikaday-wrapper">
                <input readOnly={true} ref={pikadayNode => { this.pikadayNode = pikadayNode; }} id={`field-${this.props.datepickerID}`} type="text" className="react-pikaday" placeholder={this.props.placeholderText} />
            </div>
        );
    }
}

export default Datepicker;
